module.exports = __webpack_public_path__ + "img/ep2-6.2c3cc241.png";